import {StylesConfig} from 'react-select';

const customStylesInput: StylesConfig = {
    container: () => ({
        width: '100%',
    }),
    valueContainer: provided => ({
        ...provided,
        padding: '0.5rem 0.625rem',
    }),
    dropdownIndicator: () => ({
        display: 'flex',
        alignItems: 'center',
        marginRight: '0.94rem',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    clearIndicator: () => ({
        display: 'none',
    }),
    placeholder: provided => ({
        ...provided,
        margin: '0',
        paddingLeft: '0.625rem',
    }),
    control: (provided, state) => ({
        ...provided,
        backgroundColor: state.isDisabled ? 'transparent' : 'var(--color-white)',
        borderColor: state.hasValue ? 'var(--color-success)' : 'var(--color-cinder-gray)',
        borderRadius: '0.94rem',
        boxShadow: state.isFocused ? '0 0.75rem 1.25rem rgba(10, 57, 100, 0.25)' : 'none',
        '&:hover': {border: state.hasValue ? '1px solid var(--color-success)' : '1px solid var(--color-cinder-gray)'},
        minHeight: 'unset',
    }),
    menu: (provided, state) => ({
        ...provided,
        borderRadius: '0 0 0.625rem 0.625rem',
        boxShadow: '0 0.75rem 1.25rem rgba(10, 57, 100, 0.25)',
        margin: '-2.125rem 0 0 0',
        backgroundColor: 'var(--color-white)',
        border: state.hasValue ? '1px solid var(--color-success)' : '1px solid var(--color-cinder-gray)',
        borderTop: 'none',
        '&:before': {
            content: '""',
            position: 'absolute',
            top: '-0.625rem',
            left: '-1px',
            width: '100%',
            height: '0.625rem',
            borderRight: state.hasValue ? '1px solid var(--color-success)' : '1px solid var(--color-cinder-gray)',
            borderLeft: state.hasValue ? '1px solid var(--color-success)' : '1px solid var(--color-cinder-gray)',
            backgroundColor: 'var(--color-white)',
        },
    }),
    menuList: provided => ({
        ...provided,
        fontWeight: 'normal',
        textAlign: 'left',
    }),
    multiValue: provided => ({
        ...provided,
        backgroundColor: '#edf2f7',
        color: 'var(--color-black)',
        borderRadius: '0.375rem',
    }),
    multiValueLabel: provided => ({
        ...provided,
        color: 'var(--color-falcon-gray)',
        fontSize: '0.75rem',
        lineHeight: '1.19rem',
        letterSpacing: '0.0125rem',
        fontWeight: '500',
        alignSelf: 'center',
    }),
    multiValueRemove: () => ({
        cursor: 'pointer',
        padding: '0 0.25rem 0 0.25rem',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {color: 'var(--color-error)'},
    }),
    option: (styles, state) => ({
        ...styles,
        padding: '0.5rem 1rem',
        cursor: 'default',
        backgroundColor: state.isFocused ? 'var(--color-main-blue)' : 'var(--color-white)',
        color: state.isFocused ? 'var(--color-white)' : 'var(--color-falcon-gray)',
        '&:not(:last-child)': {
            borderBottom: '1px solid var(--color-cinder-gray)',
        },
    }),
    noOptionsMessage: provided => ({
        ...provided,
        textAlign: 'left',
        paddingLeft: '0.625rem',
        color: 'var(--color-falcon-gray)',
    }),
};

const customStylesInputTeam: StylesConfig = {
    container: () => ({
        width: '100%',
    }),
    valueContainer: provided => ({
        ...provided,
        padding: '0.8rem 0.625rem',
    }),
    dropdownIndicator: () => ({
        display: 'flex',
        alignItems: 'center',
        marginRight: '0.94rem',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    clearIndicator: () => ({
        display: 'none',
    }),
    placeholder: provided => ({
        ...provided,
        margin: '0',
        paddingLeft: '0.625rem',
    }),
    control: (provided, state) => ({
        ...provided,
        backgroundColor: state.isDisabled ? 'transparent' : 'var(--color-white)',
        borderColor: state.hasValue ? 'var(--color-success)' : 'var(--color-cinder-gray)',
        borderRadius: '0.94rem',
        boxShadow: state.isFocused ? '0 0.75rem 1.25rem rgba(10, 57, 100, 0.25)' : 'none',
        '&:hover': {border: state.hasValue ? '1px solid var(--color-success)' : '1px solid var(--color-cinder-gray)'},
        minHeight: 'unset',
    }),
    menu: (provided, state) => ({
        ...provided,
        borderRadius: '0 0 0.625rem 0.625rem',
        boxShadow: '0 0.75rem 1.25rem rgba(10, 57, 100, 0.25)',
        margin: '-2.125rem 0 0 0',
        backgroundColor: 'var(--color-white)',
        border: state.hasValue ? '1px solid var(--color-success)' : '1px solid var(--color-cinder-gray)',
        borderTop: 'none',
        '&:before': {
            content: '""',
            position: 'absolute',
            top: '-0.625rem',
            left: '-1px',
            width: '100%',
            height: '0.625rem',
            borderRight: state.hasValue ? '1px solid var(--color-success)' : '1px solid var(--color-cinder-gray)',
            borderLeft: state.hasValue ? '1px solid var(--color-success)' : '1px solid var(--color-cinder-gray)',
            backgroundColor: 'var(--color-white)',
        },
    }),
    menuList: provided => ({
        ...provided,
        fontWeight: 'normal',
        textAlign: 'left',
    }),
    multiValueRemove: () => ({
        display: 'flex',
        alignItems: 'center',
    }),
    option: (styles, state) => {
        const level = {
            1: {
                paddingLeft: '0.625rem',
            },
            2: {
                paddingLeft: '1.875rem',
            },
            3: {
                paddingLeft: '3.75rem',
            },
        };

        const type = {
            global: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
            },
            region: {
                fontSize: '1.125rem',
                fontWeight: '500',
            },
            bu: {
                fontSize: '1rem',
                fontWeight: '400',
            },
        };

        return ({
            ...styles,
            padding: '0.5rem 1rem',
            cursor: 'default',
            color: state.isSelected ? 'var(--color-white)' : 'var(--color-falcon-gray)',
            backgroundColor: state.isSelected ? 'var(--color-main-blue)' : 'var(--color-white)',
            marginBottom: '0.2rem',
            '&:not(:last-child)': {
                borderBottom: '1px solid var(--color-cinder-gray)',
            },
            '&:hover': {
                backgroundColor: state.isSelected ? 'var(--color-main-blue)' : '#E8EEFE',
            },
            ...level[(state.data as {level: '1' | '2' | '3'}).level],
            ...type[(state.data as {type: 'global' | 'region' | 'bu'}).type],
        });
    },
    noOptionsMessage: provided => ({
        ...provided,
        textAlign: 'left',
        paddingLeft: '0.625rem',
        color: 'var(--color-falcon-gray)',
    }),
};

export {
    customStylesInput,
    customStylesInputTeam,
};
